import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import '../../../../../scss/weekpicker.css';
import '../../../../../scss/modernDatePicker.css';
import CustomCalendarPicker from '../../../../common/CustomWeekPicker/CustomCalendarPicker';
import { getFirstDayOFMonth } from '../../../../../utils/helpers';
import { calendarTypes } from '../../../../../utils/constants';
import CustomMonthPicker from '../../../../common/CustomMonthPicker/CustomMonthPicker';
import classes from './DateStep.module.scss';
import { submissionEnum } from '../../../../../utils/enums';

export default function DateStep({
  setDate,
  type = submissionEnum.WEEKLY,
  choosedDate,
  choosedMonth,
  disabledBefore = false
}) {
  const { t } = useTranslation();
  const [newDate, setNewDate] = useState(dayjs(choosedDate));
  const [month, setMonth] = useState(choosedMonth);
  const [year, setYear] = useState(dayjs().year());
  const [initCall, setInitCall] = useState(!!choosedDate);

  useEffect(() => {
    if (type === submissionEnum.MONTHLY && month && year && !initCall) {
      setDate(getFirstDayOFMonth(new Date(year, month).toString()));
    }
    setInitCall(false);
  }, [month, year]);

  return (
    <div className={classes.container}>
      <p className={classes.text}>
        {type === submissionEnum.WEEKLY
          ? t('dashboard.createtimesheet.steps.selectweek')
          : t('dashboard.createtimesheet.steps.selectmonth')}
      </p>
      {type === submissionEnum.WEEKLY ? (
        <CustomCalendarPicker
          userDate={newDate}
          setUserDate={(date) => {
            setNewDate(date);
            setDate(new Date(date.toString()));
          }}
          calendarType={calendarTypes.WEEK}
          backgroundColor="#FEFEFE"
          disabledBeforeIncluded={disabledBefore}
        />
      ) : (
        <CustomMonthPicker
          month={month}
          year={year}
          setMonth={setMonth}
          setYear={setYear}
          backgroundColor="#FEFEFE"
          disabledBeforeIncluded={disabledBefore}
        />
      )}
    </div>
  );
}
